<a routerLink="/resultat" class="tilbake-link" (click)="onTilbakeKlikk()">
    <img class="arrow" src="/assets/images/arrow-left.svg" alt="Arrow" />
    <span>Tilbake</span>
</a>
